











































import { Vue } from "../../constants/constants";
import { constants } from "http2";
import {
  BasketLoadersEnum,
  genericErrorsEnum
} from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("leave-group", {
  data() {
    return {
      staticContent,
      hasError: false,
      basketLoader: BasketLoadersEnum
    };
  },
  computed: {
    bindConditionalClasses(){
    return  this.$root.bindConditionalClasses;
    },
    basket() {
      return this.$store.getters.getBasket;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    }
  },
  methods: {
    hideModal() {
      this.$root.modalToggler('leave-group-modal', 'hide');
    },
    leaveGroup() {
      this.hasError = false;
      this.$root.alertClosed.URL=
       this.$root.URLBuilder.restaurantURL(
          this.groupBasket.ref.restaurant ? this.groupBasket.ref.restaurant.name:'',
          this.groupBasket.ref.restaurant? this.groupBasket.ref.restaurant.shortCode:'',
          this.userCityName? this.userCityName:'cairo', '',
          this.$root.lang?this.$root.lang:'EN',
          this.groupBasket.ref.branch?('-'+ this.groupBasket.ref.branch.shortCode):'');
      this.hideModal();
      if (navigator.onLine) {
         this.$root.pushMixpanelEvent(
                this.$root.mixpanelEvents.leaveGroup.event,
                this.$root.mixpanelEvents.leaveGroup.properties(
                  this.groupBasket.ref.restaurant.name?this.groupBasket.ref.restaurant.name:"N/A",
                ));
        this.$store
          .dispatch("LEAVE_BASKET", this.groupBasket.uuid)
          .then(() => {
            this.hasError = false;
             if (window.location.href.indexOf('/group') > 0 && window.location.href.indexOf('?groupUUID') > 0)
       {
              window.location.href=this.$root.alertClosed.URL;
       }
          })
          .catch(() => {
            this.$root.handleGenericErrors(
              genericErrorsEnum.generic,
              "leave",
              {},
              null,
              this.groupBasket.uuid
            );
          })
          .catch(() => {
            this.hasError = true;
          });
      } else {
        this.$root.handleGenericErrors(
          genericErrorsEnum.internet,
          "leave",
          {},
          null,
          this.groupBasket.uuid
        );
      }
    }
  }
});
